import { createContext, useContext } from 'react'

import type { BillingPlan, License } from '@/modules/licenses/types.ts'

export interface ModifyLicenseContextType {
  licenses?: License[] | null
  plans: BillingPlan[]
}

export const ModifyLicenseContext = createContext<
  ModifyLicenseContextType | undefined
>(undefined)

export function useModifyLicenseContext() {
  const context = useContext(ModifyLicenseContext)

  if (context === undefined) {
    throw new Error(
      'useCourse must be used within ModifyLicenseContextProvider',
    )
  }

  return context
}
